<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <template>
      <v-row class="mx-auto pa-2" no-gutters >
        <v-col
          class="pa-2 sticky-md"
          cols="12"
          md="4"
          style="top: 100px; height: fit-content"
        >
          <div class="sticky-preview">
          <component :is="data.designSettings.theme" v-model="data" :orders.sync="data.orders"/>
        </div>
        </v-col>

        <v-col cols="12" md="8">
          <v-card :disabled="loading" flat>
            <v-stepper v-model="e6" class="px-0 mx-0 qr-stepper" flat vertical>
              <v-stepper-step :complete="e6 > 1" class="px-0 px-md-4" step="1">
                <div class="row justify-center">
                  <div class="col-md-12">
                    <p>وارد کردن اطلاعات سوشال مدیا</p>
                  </div>
                  <div class="col-md-6 mt-0 pt-0">
                    <div class="rowinfo">
                      <v-text-field
                        v-model="res.title"
                        :disabled="e6 > 1"
                        append-icon="mdi-pen"
                        class="mt-0 pt-0"
                        clear-icon="mdi-close-circle-outline"
                        clearable
                        dense
                        label="نام کانال اجتماعی"
                        outlined
                      />
                      <help-info
                        :element-name="`${serviceName}-${componentName}-res-title`"
                        :service-name="serviceName"
                        :help-data="helpData"
                        class="buttoninfo"
                        label="نام کانال اجتماعی"
                      />
                    </div>
                  </div>
                </div>
              </v-stepper-step>
              <v-stepper-content class="pr-1 mx-0 mr-md-7 px-md-4" step="1">
                             <list-expansion
                  flat
                  icon="pencil-ruler"
                  single
                  :title="$t('select_template_design')"
                >
                  <template v-slot:content>
                  <theme-layout-selector v-model="data.designSettings" />
                  </template>
                </list-expansion>
                <list-expansion
                  v-model="data"
                  :components="specialInfo"
                  :data="data"
                  flat
                />

                <div class="col-md-12">
                  <next-btn
                    :loading="loading"
                    style="background: #1b8d39"
                    @click="markQr(true)"
                  />
                </div>
              </v-stepper-content>
            </v-stepper>
          </v-card>
        </v-col>
      </v-row>
    </template>
  </help-info-wrapper>
</template>

<script>
import QrMaker from "@/view/pages/qrland/components/qrMaker";
import SocialMobile from "@/view/pages/otherQrTypes/socialMedia/component/socialMobile";
import ListExpansion from "@/view/content/fragments/listExpansion";
import NextBtn from "@/view/content/fragments/nextBtn";
import QrManagement from "@/view/pages/qrland/components/qrManage/qrManagement";
import PrevBtn from "@/view/content/fragments/prevBtn";
import { Bus } from "@/main";
import { mapActions } from "vuex";
import socialMobile1_ok from "@/view/pages/otherQrTypes/socialMedia/component/socialMobile1_ok.vue";
import socialMobile2_ok from "@/view/pages/otherQrTypes/socialMedia/component/socialMobile2_ok.vue";
import socialMobile3_ok from "@/view/pages/otherQrTypes/socialMedia/component/socialMobile3_ok.vue";
import socialMobile4_ok from "@/view/pages/otherQrTypes/socialMedia/component/socialMobile4_ok.vue";
import ThemeLayoutSelector from "../otherQrTypes/socialMedia/ThemeLayoutSelector.vue";

export default {
  name: "editSocialModel",
  props:{
    id:{type:String, default:''},
  },
  components: {
    PrevBtn,
    QrManagement,
    NextBtn,
    ListExpansion,
    SocialMobile,
    QrMaker,
    socialMobile1_ok,
    socialMobile2_ok,
    socialMobile3_ok,
    socialMobile4_ok,
    ThemeLayoutSelector

  },

  data() {
    return {
      orders: [],
      showGatewayPopup: this.$route?.query?.gateway === 'true',
      helpData: [],
      serviceName: "Qrland",
      componentName: "editSocial",

      e6: 1,
      qrShow: 1,
      svgMade: "",
      destinationUrl: "",
      createdId: null,
      dtUrl: null,
      shortId: null,
      showDialog: true,
      loading: false,
      errors: {},
      data: {},
      res: {},
      qrDesign: {},
      cons: { title: "دانلود کیوآر" },
      specialInfo: [
        {
          name: "bannerSelector",
          value: "",
          title: "آپلود عکس",
          icon: "image",
          model: "banner",
        },
        {
          name: "baseInfo",
          value: "",
          title: "اطلاعات",
          icon: "account-outline",
        },
        {
          name: "imageUploader",
          value: "",
          title: "آپلود لوگو",
          icon: "image",
          model: "photo",
        },
        {
          name: "socialMediaIcons",
          value: "",
          title: "افزودن شبکه های اجتماعی",
          subtitle: "",
          icon: "instagram",
          model: "socialMedia",
        },
      ],
    };
  },

  mounted() {
    this.fetchData();
    Bus.$on("socialMedias", (value) => {
      this.data.socialMedia = value;
    });
  },  computed: {
    
    domainName() {
      return this.$route.params?.name?.replace('?gateway=true','');
    },
    qrId() {
      return this.$route.params?.id?.replace('?gateway=true','');
    },
  },


  methods: {
    ...mapActions("localstorage", ["setCreatedQrID"]),
      onCancel() {
      this.goto('qr/list');
    },
    handleEditAll() {
      this.showGatewayPopup = false;
    },

    fetchData() {
      this.loading = true;

      this.$api
        .get(`qr/template/${this.id}`)
        .then(({ data }) => {
          let parsedData =
            typeof data.data.qr.data === "string"
              ? JSON.parse(data.data.qr.data)
              : data.data.qr.data;

          let info = parsedData; 
          if (!info.orders || info?.orders?.length === 0) {
            this.$set(info, 'orders', [        
              { name: 'banner' },
              { name: 'profile' },
              { name: 'about' },
              { name: 'socialMedia' },
          ]);
          }
          if (!info?.designSettings) {
            info.designSettings = {
              theme: "socialMobile4_ok",
              layout: "SocialGrid2"
            };
          }

          this.setCreatedQrID(data.data.id);
          this.res = data.data;
          this.data = info.data;
        })
        .catch(({ response }) => {
          this.$toast.error("خطا در دریافت اطلاعات!");
          console.log("error in get social data: ", response);
        })
        .finally(() => (this.loading = false));
    },
    markQr(final = false) {
      this.loading = true;
      let obj = {
        type: "SocialMedia",
        qrType: "dynamic",
        title: this.res.title,
        data: JSON.stringify({
          theme: '',
          data: this.data,
        }),
        qr: {
          section: "#link", link: "https://qr2.in/", backcolor: "#ffffff", frontcolor: "#000000", gradient_color: "#000000", marker_out_color: "#000000", marker_in_color: "#000000", marker_top_right_outline: "#000000", marker_top_right_center: "#000000", marker_bottom_left_outline: "#000000", marker_bottom_left_center: "#000000", framecolor: "#000000", optionlogo: "none", "logo-size": 100, marker: "default", marker_in: "default", outer_frame: "none", framelabel: "SCAN ME", label_font: "AbrilFatface.svg", "label-text-size": 100, size: "248", level: "M",
        },
      };

      this.$api
        .put(`qr/template/${this.id}`, {
          qr: obj,
          type: "SocialMedia",
          title: this.res.title,
        })
        .then((res) => {
          this.$toast.success("شبکه های اجتماعی شماباموفقیت ویرایش شد.");
          this.$router.replace({ name: "modelsList" });
        })
        .catch((err) => {
          this.loading = false;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped></style>
